var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoEvent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70,
    r: 70,
    fill: "#F2FBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.834 46.333V56.9997",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.166 46.333V56.9997",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6413 57H54.3079C51.3624 57 48.9746 59.3878 48.9746 62.3333V99.6667C48.9746 102.612 51.3624 105 54.3079 105H85.501C88.501 101.5 94.0273 95.5 96.501 93L96.9746 62.3333C96.9746 59.3878 94.5868 57 91.6413 57Z",
    fill: "#CAF0F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 86.3337V57.0003C91.5 55.5858 90.9381 54.2293 89.9379 53.2291C88.9377 52.2289 87.5812 51.667 86.1667 51.667H48.8333C47.4188 51.667 46.0623 52.2289 45.0621 53.2291C44.0619 54.2293 43.5 55.5858 43.5 57.0003V94.3337C43.5 95.7481 44.0619 97.1047 45.0621 98.1049C46.0623 99.1051 47.4188 99.667 48.8333 99.667H78.1667L91.5 86.3337Z",
    fill: "#ADE8F4",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 99.667V89.0003C75.5 87.5858 76.0619 86.2293 77.0621 85.2291C78.0623 84.2289 79.4188 83.667 80.8333 83.667H91.5",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 62.666H91.5",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8909 84.216C63.3202 84.216 62.7842 84.1093 62.2829 83.896C61.7815 83.6773 61.3469 83.368 60.9789 82.968C60.6162 82.568 60.3522 82.096 60.1869 81.552L61.8029 81.104C61.9575 81.6 62.2269 81.9813 62.6109 82.248C62.9949 82.5093 63.4215 82.6373 63.8909 82.632C64.3122 82.6267 64.6829 82.528 65.0029 82.336C65.3229 82.144 65.5735 81.8853 65.7549 81.56C65.9362 81.2293 66.0269 80.8507 66.0269 80.424C66.0269 79.784 65.8269 79.256 65.4269 78.84C65.0322 78.424 64.5149 78.216 63.8749 78.216C63.6935 78.216 63.5069 78.2427 63.3149 78.296C63.1282 78.3493 62.9522 78.4187 62.7869 78.504L62.0029 77.184L66.0669 73.592L66.2429 74.072H60.6429V72.48H67.5709V74.072L64.1949 77.32L64.1789 76.776C64.9042 76.776 65.5335 76.9387 66.0669 77.264C66.6002 77.584 67.0109 78.0213 67.2989 78.576C67.5922 79.1253 67.7389 79.7413 67.7389 80.424C67.7389 81.16 67.5655 81.8133 67.2189 82.384C66.8775 82.9547 66.4162 83.4027 65.8349 83.728C65.2589 84.0533 64.6109 84.216 63.8909 84.216ZM71.8311 84V74.32L69.6631 75.64V73.776L71.8311 72.48H73.5351V84H71.8311Z",
    fill: "#0096C7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 64.5C103.404 64.5 109 58.9036 109 52C109 45.0964 103.404 39.5 96.5 39.5C89.5964 39.5 84 45.0964 84 52C84 58.9036 89.5964 64.5 96.5 64.5Z",
    fill: "white",
    stroke: "#0096C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 44.5V52L101.5 54.5",
    stroke: "#0096C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEvent);
export default __webpack_public_path__ + "static/media/NoEvent.88078f6e0a82eedd9880452492131d59.svg";
export { ForwardRef as ReactComponent };